import React, { useState,useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchTables } from "../../redux/action";
import { SectionLoader } from "../../component/common/Loader";
import EmptyScreen from "../../component/common/EmptyScreen";
import "./QrCodePage.css";

const qrList = [
  { tableNo: 1 },
  { tableNo: 2 },
  { tableNo: 3 },
];

const QrCodePage = () => {
  const [search, setSearch] = useState("");
  const { tables = [], loading, error } = useSelector((state) => state.admin);
  const dispatch = useDispatch();


     useEffect(() => {
        dispatch(fetchTables());
      }, [dispatch]);

  const filteredList = tables.filter(q =>
    q.tableName?.toString().includes(search)
  );

  const downloadQrCode = (base64String, tableName) => {
  const link = document.createElement("a");
  link.title = `Scan me!`;
  link.href = `data:image/png;base64,${base64String}`;
  link.download = `Table-${tableName}-QR.png`; // file name
  link.click();
  };

  const printQrCode = (base64String, tableName) => {
  const printWindow = window.open("", "_blank");
  printWindow.document.write(`
    <html>
      <head>
        <title>Print QR Code - Table ${tableName}</title>
        <style>
          body { text-align: center; font-family: Arial, sans-serif; }
          h2 { margin-top: 5px; }
        </style>
      </head>
      <body>
        <h2>Hungry? scan me!</h2>
        <img src="data:image/png;base64,${base64String}" />
        <script>
          window.onload = function() {
            window.print();
            window.onafterprint = function() { window.close(); };
          }
        </script>
      </body>
    </html>
  `);
  printWindow.document.close();
};



  return (
    <div className="qr-page">
      <div className="qr-header">
        <h2>QR Code</h2>
        <div className="qr-actions">
          {/* <a href="#" className="download-all">Download All QR Code</a> */}
          <a
  href="#"
  className="download-all"
  onClick={(e) => {
    e.preventDefault();
    tables.forEach((t) => {
      if (t.qrCodeImage) {
        downloadQrCode(t.qrCodeImage, t.tableName);
      }
    });
  }}
>
  Download All QR Code
</a>

          <input
            type="text"
            placeholder="Search by table no."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      <div className="qr-grid">
        {loading ? (
          <SectionLoader label="Loading QR codes..." rows={4} />
        ) : filteredList.length === 0 ? (
          <EmptyScreen
            className="qr-empty-state"
            message={tables.length ? "No matching table found." : "No table QR codes available."}
            subText={tables.length ? "Clear the search or enter another table number." : "Add tables from Settings to generate their QR codes."}
            actionLabel={tables.length && search ? "Clear search" : undefined}
            onAction={tables.length && search ? () => setSearch("") : undefined}
          />
        ) : filteredList.map((item) => (
          <div className="qr-card" key={item.restaurantTableId}>
            <div className="qr-image">
              <span className="scan-text">Scan me!</span>
              <img
                src={`data:image/png;base64,${item.qrCodeImage }`}
              />
            </div>
            <div className="qr-info">
              <p><strong>Table No.:</strong> {item.tableName}</p>
              <a href="#" className="qr-link" onClick={(e) => { e.preventDefault(); printQrCode(item.qrCodeImage, item.tableName); }}>Print /</a>
              <a
  href="#"
  className="qr-link"
  onClick={(e) => {
    e.preventDefault();
    downloadQrCode(item.qrCodeImage, item.tableName);
  }}
>
  Download
</a>

            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QrCodePage;
